import React, { memo, ReactNode } from "react";

import { Tooltip } from "../../../tooltip/Tooltip";
import { showValue } from "../../helpers";

interface DeviceNameCellProps {
  name?: string;
}

export const DeviceNameCell = memo<DeviceNameCellProps>(({ name = "" }) => {
  let content: ReactNode | string = showValue(name);

  if (name.length > 15) {
    content = (
      <Tooltip placement="top-start" content={name} autoWidth>
        {name}
      </Tooltip>
    );
  }

  return <div className="device-name">{content}</div>;
});

export const DeviceNameCellMobile = memo<DeviceNameCellProps>(({ name }) => {
  return <span className="device-name">{showValue(name)}</span>;
});
